import React, { useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import strings from 'strings'
import { fleetOauthCallbackTarget } from './fleetOauthReturn'

const FleetOauthBounce: React.FC = () => {
  const target = fleetOauthCallbackTarget(
    process.env.REACT_APP_FLEET_OAUTH_CALLBACK_URL,
    window.location.search
  )

  useEffect(() => {
    if (target) {
      window.location.replace(target)
    }
  }, [target])

  if (target) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        p: 4,
      }}
    >
      <Typography variant="h5" sx={{ textAlign: 'center' }}>
        {strings.FLEET_OAUTH_RETURN_FAILED_TITLE}
      </Typography>
      <Typography variant="subtitle2" sx={{ textAlign: 'center' }}>
        {strings.FLEET_OAUTH_RETURN_FAILED_MESSAGE}
      </Typography>
    </Box>
  )
}

export default FleetOauthBounce
